export default __webpack_public_path__ + "static/media/vk.e65fca97.png";